export default __webpack_public_path__ + "images/amazon-short-logo.svg";